import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalChooseFederationComponent } from '../../modal-choose-federation/modal-choose-federation.component';
import { ModalAddPersonComponent } from '../modal-add-person/modal-add-person.component';
import { Person } from '../../../models/person';
import { Usef_person } from '../../../models/usef/usef_person';
import { Ec_member } from '../../../models/ec/ec_member';


@Injectable({
  providedIn: 'root'
})
export class AddPersonViewService {

  constructor(private modal: NgbModal) { }


  doAddPerson(federation_code?: string, country_iso_3?: string): Promise<Person> {

    return new Promise((resolve, reject) => {

      const modal_ref = this.modal.open(ModalChooseFederationComponent, { size: 'lg' });
      modal_ref.componentInstance.entity_type = 'Person';
      modal_ref.componentInstance.event_federation_code = federation_code;
      modal_ref.componentInstance.country_iso_3 = country_iso_3;

      modal_ref.componentInstance.usef_person_selected$.subscribe((usef_person: Usef_person) => {
        modal_ref.close();

        const person: Person = new Person({
          id: null,
          first_name: usef_person.first_name,
          last_name: (usef_person.entity_type === 'I' ? usef_person.last_name : usef_person.name),
          city: usef_person.city,
          state: usef_person.state,
          postal_code: usef_person.zip,
          country: usef_person.country,
          usef_person_uuid: usef_person.uuid,
          usef_number: usef_person.id,
          usef_entity_type: usef_person.entity_type
        });

        this.openAddPersonModal(person, usef_person, resolve, reject);
      }, error => {
        reject(error);
      });

      modal_ref.componentInstance.ec_member_selected$.subscribe((ec_member: Ec_member) => {
        modal_ref.close();

        const person: Person = new Person({
          id: null,
          first_name: ec_member.Firstname,
          last_name: ec_member.Lastname,
          city: ec_member.City,
          state: ec_member.Province,
          postal_code: '',
          country: 'CA',
          ec_number: String(ec_member.EC_Sport_License_Number),
          usef_person_uuid: null,
          usef_number: '',
          usef_entity_type: ''
        });

        this.openAddPersonModal(person, null, resolve, reject);
      }, error => {
        reject(error);
      });

      modal_ref.componentInstance.skipped$.subscribe(() => {
        modal_ref.close();

        const person: Person = new Person({
          id: null,
          first_name: '',
          last_name: '',
          city: '',
          state: '',
          postal_code: '',
          country: '',
          usef_person_uuid: null,
          usef_number: '',
          usef_entity_type: ''
        });

        this.openAddPersonModal(person, null, resolve, reject);
      }, error => {
        reject(error);
      });

    });

  }


  private openAddPersonModal(
    person: Person,
    usef_person: Usef_person | null,
    resolve: (p: Person) => void,
    reject: (e: any) => void
  ): void {
    const modal_add = this.modal.open(ModalAddPersonComponent, { size: 'lg' });
    modal_add.componentInstance.person = person;
    if (usef_person) {
      modal_add.componentInstance.usef_person = usef_person;
    }

    modal_add.componentInstance.person_saved$.subscribe((saved_person: Person) => {
      modal_add.close();
      resolve(saved_person);
    }, error => {
      reject(error);
    });

    modal_add.componentInstance.existing_person_selected$.subscribe((existing: Person) => {
      modal_add.close();
      resolve(existing);
    });
  }

}
